const normalizeSentence = (value: unknown) =>
  String(value || '').replace(/[\s*。！？!?，,、；;：“”‘’'"（）()《》〈〉]/g, '');

const parseExplanationAnswer = (explanation: unknown) => {
  const match = String(explanation || '').match(
    /(?:Susunan yang benar|Kalimat yang benar|正确顺序|正确答案)\s*[:：]\s*\**\s*([^\r\n]+)/i
  );
  return match ? String(match[1] || '').replace(/\*+\s*$/, '').trim() : '';
};

const parseExplanationOptionOrder = (explanation: unknown, options: string[]) => {
  const line = String(explanation || '').match(
    /(?:Urutan yang benar|Susunan yang benar|正确顺序)\s*[:：]\s*\**\s*([^\r\n]+)/i
  )?.[1] || '';
  const letters = line.match(/\b[A-Z]\b/gi) || [];
  if (letters.length === options.length) {
    const ordered = letters.map(letter => options[letter.toUpperCase().charCodeAt(0) - 65]);
    if (ordered.every(Boolean)) return ordered;
  }
  const numbers = line.match(/\d+/g) || [];
  if (numbers.length === options.length) {
    const ordered = numbers.map(value => options[Number(value) - 1]);
    if (ordered.every(Boolean)) return ordered;
  }
  return [];
};

export const buildCorrectSequence = (question: any): string[] => {
  const options = Array.isArray(question?.options)
    ? question.options.map((value: unknown) => String(value).trim()).filter(Boolean)
    : [];
	const explanationOrder = parseExplanationOptionOrder(question?.explanation, options);
	if (explanationOrder.length > 0) return explanationOrder;
  if (options.length > 0) return options;

  const source = String(question?.question ?? question?.question_text ?? '')
    .split(';')
    .map(token => token.trim())
    .filter(Boolean);
  const target = normalizeSentence(parseExplanationAnswer(question?.explanation));
  if (source.length === 0 || !target) return [];

  const visit = (remaining: string[], ordered: string[], joined: string): string[] | null => {
    if (remaining.length === 0) return joined === target ? ordered : null;
    for (let index = 0; index < remaining.length; index++) {
      const token = remaining[index];
      const nextJoined = joined + normalizeSentence(token);
      if (!target.startsWith(nextJoined)) continue;
      const result = visit(
        remaining.filter((_value, candidateIndex) => candidateIndex !== index),
        [...ordered, token],
        nextJoined
      );
      if (result) return result;
    }
    return null;
  };

  const exact = visit(source, [], '');
  if (exact) return exact;

  const visitAsSubsequence = (remaining: string[], ordered: string[], cursor: number): string[] | null => {
    if (remaining.length === 0) return ordered;
    for (let index = 0; index < remaining.length; index++) {
      const token = remaining[index];
      const normalizedToken = normalizeSentence(token);
      const position = target.indexOf(normalizedToken, cursor);
      if (position < 0) continue;
      const result = visitAsSubsequence(
        remaining.filter((_value, candidateIndex) => candidateIndex !== index),
        [...ordered, token],
        position + normalizedToken.length
      );
      if (result) return result;
    }
    return null;
  };

  return visitAsSubsequence(source, [], 0) || [];
};

export const isSequenceReviewQuestion = (question: any, fallbackLevel?: number) => {
	const part = String(question?.part || '').trim().toUpperCase();
	const level = Number(question?.level ?? fallbackLevel ?? 0);
	return part === 'W1' || (level === 4 && part === 'R3') || String(question?.question || '').includes(';');
};

export const shouldUseLocalTestReview = (testId: unknown) => {
	const id = String(testId || '');
	return id.startsWith('practice-') || id.startsWith('wrong-view-');
};
